export interface StorageState {
    articleTemplate?: 'gallery' | 'list';
    tokens: {
        access: null | {
            injectionToken?: string,
            createdTimestampInSeconds: number,
            expiredIn: number
        }
        refresh: null | {
            createdTimestampInSeconds: number,
            expiredIn: number
        }
    }
    shoppingCart: null | {
        id?: string;
        token?: string;
        deliveryType: 'delivery' | 'pickup' | 'event' | undefined;
        dynamicArticleIds?: {
            tour?: string[],
            customer?: string[],
            deselected?: string[]
        };
    };
    readNews: string[];
    userId: null | string;
    userPostcode?: string;
    userTown?: string;
    showDeliveryAreaSelection: boolean;
    customer?: {
        id: string;
        selectedBillingAddressId: string;
        selectedDeliveryAddressId: string;
    }
}

export const initialStorageState = (): StorageState => {
    return {
        tokens: {
            access: null,
            refresh: null
        },
        readNews: [],
        shoppingCart: null,
        userId: null,
        showDeliveryAreaSelection: false
    };
};
